import React from "react";
import { Typography } from "@material-ui/core";

function page404(match) {
  return (
    <>
      <Typography variant="h5" component="h5" align="center">
        존재하지 않는 페이지 입니다.
      </Typography>
      <hr />
    </>
  );
}
export default page404;
